import { type Command } from '@telespot/core';

/**
 * Details for {@link CreateInvitation}
 *
 * @group Authentication & Authorization
 * @category Payloads
 */
export interface CreateInvitationDetails {
  organizationId: string;
  code: string;
  uses: number;
  initialWorkspaces: string[];
  initialRoles: string[];
}

/**
 * Command registration token for {@link CreateInvitation}
 *
 * @group Authentication & Authorization
 * @category Tokens
 */
export const CREATE_INVITATION = 'users:createInvitation';

/**
 * Creates a new invitation.
 */
export class CreateInvitation implements Command<typeof CREATE_INVITATION, CreateInvitationDetails> {
  public readonly name = CREATE_INVITATION;
  constructor(public readonly details: Readonly<CreateInvitationDetails>) {}
}
